module.exports = __webpack_public_path__ + "img/9788973812509.6750d2d3.jpg";